import { render, staticRenderFns } from "./EFBOccSideLogs.vue?vue&type=template&id=c64f5a58&scoped=true&"
import script from "./EFBOccSideLogs.vue?vue&type=script&lang=js&"
export * from "./EFBOccSideLogs.vue?vue&type=script&lang=js&"
import style0 from "./EFBOccSideLogs.vue?vue&type=style&index=0&id=c64f5a58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64f5a58",
  null
  
)

export default component.exports